export default __webpack_public_path__ + "static/media/logo-us-journeys.e293a489.svg";